"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const containerStyle = {
    width: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 15,
    height: 'auto',
    backgroundColor: 'gray',
};
const previewStyle = {
    flex: 1,
    position: 'relative',
};
const ContainerButtonCloseStyle = {
    position: 'absolute',
    top: 40,
    right: 40,
};
const CameraQRender = ({ cameraContext }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const [shouldTakeAPicture, setShouldTakeAPicture] = (0, react_1.useState)(false);
    const [shouldBeRecording, setShouldBeRecording] = (0, react_1.useState)(false);
    const [zoom, setZoom] = (0, react_1.useState)(0);
    const [type, setType] = (0, react_1.useState)('back');
    const [flash, setFlash] = (0, react_1.useState)('off');
    const isRecord = (0, react_1.useMemo)(() => {
        if (cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.isRecord) {
            return cameraContext.isRecord;
        }
        return false;
    }, [cameraContext]);
    const takePicture = (0, react_1.useCallback)(() => {
        setShouldTakeAPicture(true);
    }, []);
    const startRecord = (0, react_1.useCallback)(async () => {
        setShouldBeRecording(true);
    }, []);
    const stopRecord = (0, react_1.useCallback)(() => {
        setShouldBeRecording(false);
        if (cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onStopRecord) {
            cameraContext.onStopRecord();
        }
    }, [cameraContext]);
    const closeCamera = () => {
        if (cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onClose) {
            cameraContext.onClose();
        }
    };
    const zoomOut = () => {
        const zoomO = zoom - 0.1 < 0 ? 0 : zoom - 0.1;
        setZoom(zoomO);
    };
    const zoomIn = () => {
        const zoomI = zoom + 0.1 > 1 ? 1 : zoom + 0.1;
        setZoom(zoomI);
    };
    const toggleType = () => {
        const toogleT = type === 'back' ? 'front' : 'back';
        setType(toogleT);
    };
    const toggleFlash = () => {
        const toogleF = flash === 'off' ? 'torch' : 'off';
        setFlash(toogleF);
    };
    const onQRCodeRead = (0, react_1.useCallback)(() => {
        if (!(cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onQRCodeRead) && !(cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onBarCodeRead)) {
            return undefined;
        }
        return (event) => {
            const isQR = event.type === 'QR_CODE' || event.type === 'qr';
            if ((cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onQRCodeRead) && isQR) {
                cameraContext.onQRCodeRead(event);
            }
            if ((cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onBarCodeRead) && !isQR) {
                cameraContext.onBarCodeRead(event);
            }
        };
    }, [cameraContext]);
    return (react_1.default.createElement(Render.Modal, { visible: true, animationType: "slide" },
        react_1.default.createElement(Render.Camera, { shouldTakeAPicture: shouldTakeAPicture, shouldBeRecording: shouldBeRecording, style: previewStyle, type: type, zoom: zoom, flashMode: flash, captureAudio: false, androidCameraPermissionOptions: {
                title: 'Permission to use camera',
                message: 'We need your permission to use your camera',
                buttonPositive: 'Ok',
                buttonNegative: 'Cancel',
            }, onTakePicture: (uri) => {
                if (cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onTakePicture) {
                    setShouldTakeAPicture(false);
                    cameraContext.onTakePicture(uri);
                }
            }, onStartRecording: (uri) => {
                if (cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onStartRecord) {
                    cameraContext.onStartRecord(uri);
                }
            }, onStopRecording: stopRecord, onRejectedPermissions: () => {
                if (cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.onRejectedPermissions) {
                    cameraContext.onRejectedPermissions();
                }
            }, onQRBarcodeRead: onQRCodeRead() },
            react_1.default.createElement(Render.View, { style: ContainerButtonCloseStyle },
                react_1.default.createElement(Render.TouchableOpacity, { onPress: closeCamera },
                    react_1.default.createElement(Render.SvgIcon, { name: "close", size: 25, color: (flash === 'torch') ? '#ffc400' : 'white', family: "FontAwesome" }))),
            react_1.default.createElement(Render.View, { style: containerStyle },
                react_1.default.createElement(Render.TouchableOpacity, { onPress: zoomOut },
                    react_1.default.createElement(Render.SvgIcon, { name: "minus", size: 25, color: "white", family: "FontAwesome" })),
                react_1.default.createElement(Render.TouchableOpacity, { onPress: zoomIn },
                    react_1.default.createElement(Render.SvgIcon, { name: "plus", size: 25, color: "white", family: "FontAwesome" })),
                isRecord && shouldBeRecording && (react_1.default.createElement(Render.TouchableOpacity, { onPress: stopRecord },
                    react_1.default.createElement(Render.SvgIcon, { name: "video-off", size: 30, color: "white", family: "Feather" }))),
                isRecord && !shouldBeRecording && (react_1.default.createElement(Render.TouchableOpacity, { onPress: startRecord },
                    react_1.default.createElement(Render.SvgIcon, { name: "video", size: 30, color: "white", family: "Feather" }))),
                !isRecord && (react_1.default.createElement(Render.TouchableOpacity, { onPress: takePicture },
                    react_1.default.createElement(Render.SvgIcon, { name: "camera", size: 30, color: "white", family: "FontAwesome" }))),
                react_1.default.createElement(Render.TouchableOpacity, { onPress: toggleType },
                    react_1.default.createElement(Render.SvgIcon, { name: "refresh", size: 25, color: "white", family: "FontAwesome" })),
                react_1.default.createElement(Render.TouchableOpacity, { onPress: toggleFlash },
                    react_1.default.createElement(Render.SvgIcon, { name: "flash", size: 25, color: (flash === 'torch') ? '#ffc400' : 'white', family: "FontAwesome" }))))));
};
exports.default = CameraQRender;
